import { createSlice } from '@reduxjs/toolkit';
import { getAtobParsedData } from '../../utils/shape-utils';

const initialState = {
  metadata: '',
  loginFlows: '',
  logoPath: '',
  headerText: '',
  descriptionText: '',
  usernameHintText: '',
};

const clientMetadataSlice = createSlice({
  name: 'clientMetadata',
  initialState,
  reducers: {
    updateClientMetaData: (state, { payload }) => {
      const metadata = getAtobParsedData(payload);
      const {
        flows = '', logo = '', header = '', description = '', usernameHint = '',
      } = metadata;

      return {
        ...state,
        metadata,
        loginFlows: flows,
        logoPath: logo,
        headerText: header,
        descriptionText: description,
        usernameHintText: usernameHint,
      };
    },
    reset: () => initialState,
  },
});

export const {
  updateClientMetaData,
} = clientMetadataSlice.actions;

export default clientMetadataSlice.reducer;
